import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { initialize } from "@/onboarding/features/cost_analysis/Slice"
import { getCostAnalysis } from "@/onboarding/features/cost_analysis/selectors"
import LoadingSpinner from "@/components/LoadingSpinner"

import Product from "./components/Product"

const CostAnalysis = ({
  season,
  selectedBiddingRegionId,
  selectedAwardSetId,
  selectedProductId,
}): JSX.Element => {
  const dispatch = useDispatch()

  const { initialized } = useSelector(getCostAnalysis)

  useEffect(() => {
    if (!initialized) {
      dispatch(
        initialize({
          season,
          selectedBiddingRegionId,
          selectedAwardSetId,
          selectedProductId,
        })
      )
    }
  }, [initialized])

  if (!initialized) {
    return <LoadingSpinner />
  }

  return <Product />
}

export default CostAnalysis
